import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

function Row({ name, products, onLinked }) {
  const [pid, setPid] = useState("");
  const link = async () => {
    try {
      await api.post("/nayax/diagnostic/add-alias", { product_id: pid, alias: name });
      onLinked(name);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Liaison impossible");
    }
  };
  return (
    <div className="flex items-center gap-2" data-testid={`recap-unmatched-${name}`}>
      <span className="text-sm w-44 truncate" title={name}>{name}</span>
      <Select value={pid} onValueChange={setPid}>
        <SelectTrigger className="flex-1 h-8 text-xs"><SelectValue placeholder="Produit AgroManage…" /></SelectTrigger>
        <SelectContent>{products.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}</SelectContent>
      </Select>
      <Button size="sm" variant="outline" disabled={!pid} onClick={link}>Relier</Button>
    </div>
  );
}

export default function RecapUnmatched({ names, onReimport, busy }) {
  const [products, setProducts] = useState([]);
  const [linked, setLinked] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => setProducts((r.data || []).filter((p) => !p.archived)));
  }, []);
  const pending = names.filter((n) => !linked.includes(n));
  return (
    <div className="border border-[#E8CF9A] bg-[#FFF6E5] rounded-lg p-3 space-y-2" data-testid="recap-unmatched">
      <div className="text-sm font-medium text-[#8A5A00]">
        {names.length} plat(s) Nayax non reconnu(s). Reliez-les une fois : la correspondance servira aussi à la synchro Nayax.
      </div>
      {pending.map((n) => (
        <Row key={n} name={n} products={products} onLinked={(x) => setLinked((l) => [...l, x])} />
      ))}
      {linked.length > 0 && (
        <Button size="sm" onClick={onReimport} disabled={busy} className="bg-[#1F4E3D] hover:bg-[#173B2E]" data-testid="recap-reimport">
          Réimporter avec les nouvelles correspondances
        </Button>
      )}
    </div>
  );
}
